<template>
  <div class="gd-loader" :class="{'absolute w-full h-full flex flex-col justify-center items-center': type !== 'bar'}">
    <span :class="classes" v-if="label && type !== 'bar'">{{ label }}</span>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" class="groove-logo" v-if="groove">
      <path
        d="M19.722 19.852h19.326c-.829 8.975-4.942 14.896-12.34 17.763-7.397 2.866-14.386 1.433-20.966-4.3l6.906-6.626c2.51 1.84 4.869 2.76 7.074 2.76 2.206 0 4.268-.844 6.186-2.532l-6.186-7.065zM0 19.36h9.909c.391-4.854 2.702-7.9 6.933-9.137 4.23-1.236 7.798.038 10.702 3.822l7.73-6.309C28.764.456 21.24-1.686 12.701 1.312 4.814 4.08.581 10.097 0 19.36z">
      </path>
    </svg>
    <div class="gd-loader--bar bg-primary" v-else-if="type === 'bar'"></div>
    <half-circle-spinner v-else :animation-duration="1000" :dot-size="15" :dots-num="3" color="var(--brand-primary)"
      class="gd-loader--spinner" />
  </div>
</template>
<script>
import { HalfCircleSpinner } from 'epic-spinners';
import { twMerge } from 'tailwind-merge';

export default {
  name: 'GdLoader',
  components: {
    HalfCircleSpinner
  },
  props: {
    type: {
      type: String,
      default: 'spinner',
      validator: (value) => ['spinner', 'bar'].includes(value)
    },
    label: {
      type: String,
      default: ''
    },
    labelClass: {
      type: String,
      default: ''
    },
    groove: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return twMerge('text-grey-500 font-thin mb-1', this.labelClass);
    }
  }
}
</script>

<style lang="scss">
.gd-loader {
  top: 0;
  left: 0;
  z-index: 48;

  .groove-logo {
    height: 60px;
    width: 60px;
    stroke: #FD6481;
    fill: #FD6481;
    stroke-dasharray: 600;
    stroke-width: .6;
    opacity: 1;
    animation: pinkIt 5s cubic-bezier(0, 0.23, 1, .1) infinite;
    animation-delay: 0s;
    -moz-animation: pinkIt 5s cubic-bezier(0, 0.23, 1, .1) infinite;
    -webkit-animation: pinkIt 5s cubic-bezier(0, 0.23, 1, .1) infinite;
    stroke-linecap: round;
    margin: 5px auto 15px;
  }

  &--bar {
    position: relative;
    width: 0%;
    padding: 2px 0;
    margin: 0 auto;
    animation: barLoader 2s linear 0s infinite;
    top: 0;
    z-index: 1;
  }

  @keyframes barLoader {
    0% {
      width: 0%;
    }
    25% {
      width: 50%;
    }
    50% {
      width: 100%;
    }
    75% {
      width: 50%;
    }
    100% {
      width: 0%;
    }
  }
  
  @keyframes pinkIt {
    0%,
    100% {
      fill: none;
      stroke-dashoffset: 600;
      fill: rgba(255, 255, 255, 0);
      opacity: 0;
    }
  
    20% {
      fill: rgba(255, 255, 255, 0);
      opacity: 1;
      stroke-dashoffset: 600;
    }
  
    60% {
      fill: #FD6481;
      stroke-dashoffset: 0;
    }
  }
}
</style>
